import React from 'react';

const Spinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center min-h-[50vh]">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D14F8B]"></div>
    </div>
  );
};

export default Spinner;
